import { GRAPH_URL } from "../../../constants";
import { getAuthorizationHeader } from "./authorization";

const query = `
    query GetInstagramPosts($after: String) {
        getInstagramPosts(after: $after) {
            posts {
                id
                uri
                mediaType
                previewUri
                creationDate
            }
            afterCursor
        }
    }
`;

const getCurrentUser = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      ...getAuthorizationHeader(),
    },
    body: JSON.stringify({ query, variables }),
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) {
        const message = res.errors[0].message;
        throw new Error(message);
      }
      return res.data ? res.data.getInstagramPosts : {};
    });

export default getCurrentUser;
